export default [
  {
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/app/',
    menu: false,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/propostas',
    icon: 'far fa-list-alt',
    title: 'Propostas',
    view: 'Propostas',
    dir: 'views/app/Propostas/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/propostas/detalhes',
    title: 'Analisar Proposta',
    view: 'PropostasDetalhes',
    dir: 'views/app/Propostas/',
    menu: false,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/documentosPendentes',
    icon: 'fas fa-book-open',
    title: 'Documentos Pendentes',
    view: 'DocumentosPendentes',
    dir: 'views/app/DocumentosPendentes/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/notificacaoIntegracao',
    icon: 'fas fa-star-of-life',
    title: 'Notificação Integração',
    view: 'NotificacaoIntegracao',
    dir: 'views/app/NotificacaoIntegracao/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/solicitacoesAnalise',
    icon: 'fas fa-search-dollar',
    title: 'Solicitações de Análise',
    view: 'SolicitacoesAnalise',
    dir: 'views/app/SolicitacoesAnalise/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/solicitacoesAnaliseEdit',
    title: 'Solicitações de Análise Editar',
    view: 'SolicitacoesAnaliseEdit',
    dir: 'views/app/SolicitacoesAnalise/',
    menu: false,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/agendaPagamento',
    icon: 'far fa-calendar-alt',
    title: 'Agenda de Pagamento',
    view: 'AgendaPagamento',
    dir: 'views/app/AgendaPagamento/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/agendaRecebivel',
    icon: 'fas fa-calendar-alt',
    title: 'Agenda de Recebíveis',
    dir: 'views/app/AgendaRecebivel/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    },
    items: [
      {
        path: '',
        title: 'Agenda de Recebíveis',
        view: 'AgendaRecebivel',
        menu: true,
        meta: {
          roles: ['BMP.Partner.User'],
          allRolesRequired: false
        }
      },
      {
        path: '/detalhes',
        title: 'Agenda de Recebiveis',
        view: 'AgendaRecebivelDetalhes',
        menu: false,
        meta: {
          roles: ['BMP.Partner.User'],
          allRolesRequired: false
        }
      },
      {
        path: '',
        dir: 'Consultas',
        title: 'Consultas',
        menu: true,
        meta: {
          roles: ['BMP.Partner.User'],
          allRolesRequired: false
        },
        items: [
          {
            path: '/boletos',
            title: 'Boletos',
            view: '/Boletos',
            dir: '/Boletos',
            menu: true,
            meta: {
              roles: ['BMP.Partner.User'],
              allRolesRequired: false
            }
          },
          {
            path: '/logscallback',
            title: 'Logs Callback',
            view: '/LogsCallback',
            dir: '/LogsCallback',
            menu: true,
            meta: {
              roles: ['BMP.Partner.User'],
              allRolesRequired: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/limitesCredito',
    icon: 'fas fa-ruler-vertical',
    title: 'Limites de Credito',
    view: 'LimitesCredito',
    dir: 'views/app/LimitesCredito/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/funcionarios',
    icon: 'person',
    title: 'Funcionários',
    view: 'ListarPessoasFuncionarios',
    dir: 'views/app/ListarPessoasFuncionarios/',
    menu: true,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false
    }
  },
  {
    path: '/extrato',
    title: 'Extrato',
    view: 'Extrato',
    dir: 'views/app/LimitesCredito/',
    menu: false,
    meta: {
      roles: ['BMP.Partner.User'],
      allRolesRequired: false,
      isPrinting: true
    }
  },
  {
    path: '/processos/ccbdigital/assinatura',
    title: 'Assinatura',
    view: 'Assinatura',
    dir: 'views/app/AssinaturaProposta/',
    menu: false,
    meta: {
      anonymousAuth: true,
    }
  },
  {
    path: '/processos/ccbdigital/assinatura',
    title: 'Assinar',
    view: 'Assinar',
    dir: 'views/app/AssinaturaProposta/',
    menu: false,
    meta: {
      anonymousAuth: true,
    }
  },
  {
    path: '/',
    view: 'Login',
    dir: 'views/',
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['BMP.Partner.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/partner',
    view: 'Partner',
    dir: 'views/',
    title: 'Partner',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['BMP.Partner.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/senha/lembrar',
    view: 'Lembrar',
    dir: 'views/',
    title: 'Lembrar',
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['BMP.Partner.User'],
      allRolesRequired: true
    }
  },
  {
    path: '/senha/recuperar',
    view: 'Recuperar',
    dir: 'views/',
    title: 'Recuperar',
    params: true,
    menu: false,
    meta: {
      anonymousAuth: true,
      roles: ['BMP.Partner.User'],
      allRolesRequired: true
    }
  }
];
